import { render, staticRenderFns } from "./ProjectTabs.vue?vue&type=template&id=26498fea&scoped=true"
import script from "./ProjectTabs.vue?vue&type=script&lang=js"
export * from "./ProjectTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectTabs.vue?vue&type=style&index=0&id=26498fea&prod&scoped=true&lang=css"
import style1 from "./ProjectTabs.vue?vue&type=style&index=1&id=26498fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26498fea",
  null
  
)

export default component.exports